// init controller
var controller = new ScrollMagic.Controller();

// var windowOffset = $(window).height();

// build tween
/*
var tween = TweenMax.to("#parallaxHero", 0.5, {top: "-100vh"});
var tween2 = TweenMax.to(".hero__arrow", 0.5, {opacity: 0})

// build scene and set duration to window height
var scene = new ScrollMagic.Scene({ duration: "100%"})
    .setTween(tween)
    .triggerHook(0)
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

var scene2 = new ScrollMagic.Scene({ duration: "20%"})
    .setTween(tween2)
    .triggerHook(0)
    .addTo(controller);

*/
//  loop parallax reveal sections
$(".parallax-reveal").each( function () {    

    // build tween
    var tween = TweenMax.to($(this), 0.5, {top: "-100vh"});
    var tween2 = TweenMax.to($(this).find(".hero__arrow"), 0.5, {opacity: 0})

    // build scene and set duration to window height
    var scene = new ScrollMagic.Scene({duration: "100%"})
        .setTween(tween)
        .triggerHook(0)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

    var scene2 = new ScrollMagic.Scene({ duration: "20%"})
        .setTween(tween2)
        .triggerHook(0)
        .addTo(controller);

    
});    
//  loop parallax sections

// $(".parallax-section").each( function () {
    
//     var bg = $(this).find(".parallax-section__bg");
    
//     // Add tweenmax for backgroundParallax
//     var parallax = TweenMax.from( bg, 1, {
//         y: '-25%',
//         ease: Power0.easeNone
//     } );
    
//     // Create scrollmagic scene
//     var parallaxScene = new ScrollMagic.Scene({
//         triggerElement: this, // <-- Use this to select current element
//         triggerHook: 1,
//         duration: '200%',
//     })
//     .setTween(parallax)
//     // .addIndicators()
//     .addTo(controller);
    
// });